// assets/atmo-datalayer.js
(function () {
  window.dataLayer = window.dataLayer || [];

  // ------- Helpers -------
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch /cart.js');
    return await res.json();
  }

  function cartToItems(cart) {
    return (cart.items || []).map(it => ({
      item_id: String(it.variant_id),
      item_name: it.product_title || it.title || '',
      item_brand: it.vendor || '',
      item_variant: it.variant_title || '',
      price: ((it.final_price ?? it.price) || 0) / 100,
      quantity: it.quantity || 1
    }));
  }

  function pushEcomEvent(eventName, ecommerceObj) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerceObj || {}
    });
  }

  // Expose minimal helpers if you want to debug in console
  window.atmoDL = window.atmoDL || { getCart };

  /*******************************************************
 STEP 3 — begin_checkout (robuste) : source de vérité = /cart.js
 - Au clic checkout : lit /cart.js et push begin_checkout avec items cohérents
********************************************************/

(function setupBeginCheckoutCartCanonical() {
  window.dataLayer = window.dataLayer || [];
  let fired = false;

  const sstr = (v) => (v == null ? "" : String(v));

  function centsToNumber(cents) {
    const n = Number(cents);
    return Number.isFinite(n) ? n / 100 : 0;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch /cart.js");
    return res.json();
  }

  function cartLineToGA4Item(line) {
    const qty = Number(line.quantity) || 1;
    const unitPrice = centsToNumber(line.final_price ?? line.price ?? 0);
    const productName = sstr(line.product_title || "");

    return {
      item_id: sstr(line.sku || line.variant_id || line.id),
      item_name: productName,                     // ✅ produit uniquement
      item_variant: sstr(line.variant_title || ""), // ✅ taille/couleur
      item_brand: sstr(line.vendor || ""),
      item_category: sstr(line.product_type || ""),
      price: unitPrice,
      quantity: qty,
      item_variant_id: sstr(line.variant_id || ""),
      item_product_id: sstr(line.product_id || "")
    };
  }

  function textLooksLikeCheckout(el) {
    const text = (el && (el.innerText || el.value) || "").toString().toLowerCase().trim();
    return (
      text.includes("checkout") ||
      text.includes("check out") ||
      text.includes("paiement") ||
      text.includes("payer") ||
      text.includes("commander") ||
      text.includes("passer à la caisse")
    );
  }

  async function fireBeginCheckout() {
    if (fired) return;
    fired = true;

    try {
      const cart = await fetchCart();
      const lines = cart.items || [];

      const items = lines
        .map(cartLineToGA4Item)
        .filter((it) => !!it.item_name); // 🔒 si product_title manquant, on ne pollue pas

      const value = cart.total_price != null
        ? centsToNumber(cart.total_price)
        : items.reduce((acc, it) => acc + (Number(it.price) || 0) * (Number(it.quantity) || 0), 0);

      const ecommerce = {
        currency: sstr(cart.currency || "{{ shop.currency }}"),
        value,
        items
      };

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: "begin_checkout", ecommerce });
    } catch (_) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: "begin_checkout" });
    }
  }

  document.addEventListener("click", function (e) {
    const el = e.target.closest("a, button, input");
    if (!el) return;

    const isTrigger =
      (el.matches('a[href*="/checkout"]')) ||
      (el.matches('button[name="checkout"], input[name="checkout"]')) ||
      (el.matches("button.shopify-payment-button__button")) ||
      (el.hasAttribute("data-shop-pay")) ||
      ((el.getAttribute("aria-label") || "").toLowerCase().includes("shop pay")) ||
      textLooksLikeCheckout(el);

    if (isTrigger) fireBeginCheckout();
  }, true);
})();


  // ------- view_cart -------
  (function setupViewCart() {
    // 1) Cart page
    if (location.pathname === '/cart') {
      getCart().then(cart => {
        pushEcomEvent('view_cart', {
          currency: cart.currency || undefined,
          value: (cart.total_price || 0) / 100,
          items: cartToItems(cart)
        });
      }).catch(() => {});
    }

    // 2) Cart drawer / mini-cart (best-effort, theme-agnostic)
    let drawerFiredRecently = false;

    function fireDrawerViewCart() {
      if (drawerFiredRecently) return;
      drawerFiredRecently = true;
      setTimeout(() => { drawerFiredRecently = false; }, 8000); // cooldown anti-spam

      getCart().then(cart => {
        pushEcomEvent('view_cart', {
          currency: cart.currency || undefined,
          value: (cart.total_price || 0) / 100,
          items: cartToItems(cart)
        });
      }).catch(() => {});
    }

    document.addEventListener('click', function (e) {
      const trigger =
        e.target.closest('a[href="/cart"]') ||
        e.target.closest('[data-cart-drawer-open]') ||
        e.target.closest('[aria-controls*="cart"]') ||
        e.target.closest('[aria-label*="cart"], [aria-label*="panier"]');

      if (trigger) {
        // give the drawer time to open
        setTimeout(fireDrawerViewCart, 300);
      }
    }, true);
  })();

})();

(function () {
  // --- 1) Detect suggestion click (sets a flag for the next page load)
  document.addEventListener('click', function (e) {
    var results = document.getElementById('predictive-search');
    if (!results || !results.contains(e.target)) return;

    // User clicked inside predictive results => treat as suggestion
    try {
      sessionStorage.setItem('ga4_search_input_method', 'suggestion');
    } catch (err) {}
  });

  // --- 2) Fire GA4 standard search event on the search results page
  // Works for /search and /fr/search, /en/search, etc.
  var path = window.location.pathname || '';
  var isSearchPage = /\/search\/?$/.test(path);
  if (!isSearchPage) return;

  var params = new URLSearchParams(window.location.search);
  var term = (params.get('q') || '').trim();
  if (!term) return;

  var method = 'submit';
  try {
    var stored = sessionStorage.getItem('ga4_search_input_method');
    if (stored === 'suggestion') method = 'suggestion';
    sessionStorage.removeItem('ga4_search_input_method');
  } catch (err) {}

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'search',
    search_term: term,
    search_input_method: method,
    search_source: 'results_page'
  });
})();
